<form [formGroup]="payorFrmGp" (ngSubmit)="addSavePayorCollection()">

    <p class="mb-1">
        Please Import an Excel file or enter the payor details individually below. </p>
    <div class="accordion accordion-flush" id="accordionFlushExample">
        <div class="accordion-item" (click)="resetToggle()">
            <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"
                    style="font-weight: bold">
                    Import Excel File
                </button>
            </h2>
            <div id="flush-collapseOne" class="accordion-collapse collapse"
                [ngClass]="{'closed': toggleEditPayor, 'show': !toggleEditPayor && isEditPayor}"
                aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                    <div class="file-import-block mt-2 mb-2 mx-2">
                        <div class="flex-input-col pt-2 pb-2">
                            <div class="row">
                                <p>Microsoft® Excel must be installed on your device to upload or
                                    download files.</p>
                                <div class="col-12 col-lg-5 custom-file">
                                    <input id="impFile" #inputFile type="file" class="custom-file-input mb-3"
                                        multiple="false" accept=".xls,.xlsx" (change)="onFileChange($event)"
                                        (click)="resetFile()" formControlName="filename">
                                    <label class="custom-file-label" for="impFile"><i *ngIf="!fileImported"
                                            class="fa fa-search"></i>{{payorFrmGp.get('filename')!.value}}</label>
                                    <p class="c-grey6 ts-xs">{{fileImportHint}}</p>
                                </div>
                                <div *ngIf="isScheduledPaymentValidation" class="col-12 col-lg-7">
                                    <a download="ACHD Payor Example" target="_blank"
                                        href="/assets/forms/employerACHDPayorList.xlsx">
                                        Sample File
                                        <i class="fa fa-download" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <div *ngIf="isCreditCardValidation" class="col-12 col-lg-7">
                                    <a download="Credit Card Payor Example" target="_blank"
                                        href="/assets/forms/employerCCPayorList.xlsx">
                                        Sample File
                                        <i class="fa fa-download" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!isFileValid && fileImported" class="c-red1 ts-s mb-2">
                            <i matPrefix class="fa fa-exclamation-triangle pa-1"></i>{{fileErrorMessage}}
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"
                    style="font-weight: bold">
                    Enter Payor Detail
                </button>
            </h2>
            <div id="flush-collapseTwo" [ngClass]="{'closed': !toggleEditPayor, 'show': toggleEditPayor}"
                class="accordion-collapse collapse closed" aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                    <div class="payor-info-block">
                        <div formGroupName="collectionFrmGp">
                            <div class="flex-input-col pt-1 pb-1">
                                <mat-form-field>
                                    <input #LastName matInput placeholder="Last Name" formControlName="lastname">
                                </mat-form-field>
                                <mat-form-field>
                                    <input [type]="ssnHide ? 'password' : 'text'" matInput ngxInputRegulate
                                        ngxir-pattern="^[0-9 -]*$" placeholder="Social Security #"
                                        formControlName="ssn">
                                    <mat-icon matSuffix (click)="toggleSSNHide()">{{ssnHide ? 'visibility_off' :
                                        'visibility'}}
                                    </mat-icon>
                                    <mat-hint>xxx-xx-xxxx or xxxxxxxxx</mat-hint>
                                    <mat-error>Invalid Format.</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="flex-input-col pt-1 pb-1">
                                <mat-form-field *ngIf="validateCaseNumber">
                                    <input matInput placeholder="{{secondaryIdAlias}}" formControlName="casenumber">
                                    <mat-error>Required</mat-error>
                                </mat-form-field>
                                <mat-form-field>
                                    <input type="number" matInput placeholder="Amount" formControlName="amount">
                                    <mat-error>Invalid Format</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex-btn-row">
                            <button *ngIf="!isEditPayor" class="btn btn-submit" type="submit">Add</button>
                            <button *ngIf="isEditPayor" class="btn btn-submit" type="submit">Save</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <hr>
    <!-- <div class="mb-2 load-payors">
        <div class="flex-input-col pt-2 pb-2">
            <label class="smart-checkbox">
                <input type="checkbox" [checked]="previousPayorsChecked" class="form-check-input smart-checks checkmark"
                    label="get previous payment payor" (change)="getPreviousPaymentPayors($event)">
                <span class="checkmark"></span>
                Get Previous Payment Payors
            </label>
        </div>
        <div class="flex-input-col pt-2 pb-2">
            <label class="smart-checkbox mb-4">
                <input type="checkbox" [checked]="allPayorsChecked" class="form-check-input smart-checks checkmark"
                    label="get all payors" (change)="getAllPreviousPayors($event)">
                <span class="checkmark"></span>
                Get ALL Previous Payors
            </label>
            <span *ngIf="isLoadingPreviousPayors">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw ts-l"></i>
                Loading Previous Payors...
            </span>
            <span *ngIf="noPreviousPayors" class="c-red1">
                <i class="fa fa-exclamation-triangle fa-2x fa-fw ts-l"></i>
                {{noPreviousPayors}}
            </span>
        </div>
    </div> -->
    <div *ngIf="payorCollection?.length">
        <hr>
        <div class="row">
            <div class="col-12 col-md-6">
                <h4>Payors List &nbsp;&nbsp;
                    <span class=" ts-s c-red1" *ngIf="numInvalid && numWarning">{{numInvalid}}
                        Invalid payor(s) found. {{numWarning}} Payor name change(s) completed.</span>
                    <span class="ts-s c-red1" *ngIf="numInvalid && numWarning === 0">{{numInvalid}}
                        Invalid payor(s) found.</span>
                    <span class="ts-s c-gold0" *ngIf="numWarning && numInvalid === 0">{{numWarning}} Payor name
                        change(s) completed.</span>
                    <span class="ts-s c-green0" *ngIf="payorsValid">All Payors are VALID!
                    </span>
                    <span *ngIf="isValdiatingPayment" matSuffix><i
                            class="fa fa-refresh fa-spin fa-2x fa-fw ts-l"></i></span>
                </h4>
            </div>
            <div class="col-12 col-md-6 ts-s">
                <div class="flex-responsive-justify">
                    <strong class="mr-2">
                        Selected:
                        {{getNumberOfPayments()}}/{{payorCollection.length}}</strong>
                    <strong>
                        Amount:
                        <span
                            [ngStyle]="{'color': ((totalAmtOfPayments > 9999.99) && validateAttemptMade) ? 'red' : 'black'}">
                            {{totalAmtOfPayments|currency}}</span>
                    </strong>
                </div>
            </div>
        </div>
        <!-- <button style="float: left; margin: 12px; width: 80px" class="btn btn-secondary mt-1" (click)="clearPaymentCollection()">Reset</button>-->

        <!-- <button style="float: left; margin: 12px; width: 80px" class="btn btn-secondary mt-1" (click)="clearPaymentCollection()">Reset</button>-->
        <div class="paymentRecordPanel">
            <table class="table" id="paymentRecords">
                <thead>
                    <tr>
                        <th>
                            <label class="smart-checkbox">
                                <input type="checkbox" class="form-check-input smart-checks checkmark" name="Checks"
                                    [checked]="allChecked" (change)='selectAllPayments($event)'>
                                <span class="checkmark"></span>
                            </label>
                        </th>
                        <th>Name</th>
                        <th>SSN</th>
                        <th *ngIf="validateCaseNumber">{{secondaryIdAlias}}</th>
                        <th>Amount</th>
                        <th>Action</th>
                        <th>Validation</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let payor of payorCollection; let i = index" [ngClass]="{'unverifiedPayment' : payor.isSelected && !payor.isValidated && !payor.hasError,
                            'verifiedPayment' : payor.isSelected && payor.isValidated && !payor.hasError,
                            'warningPayment' : payor.isSelected && payor.hasWarning && !payor.hasError,
                            'errorPayment' : payor.isSelected && payor.hasError,
                            'editPayment' : payor.hadEdit}">
                        <td>
                            <label class="smart-checkbox">
                                <input type="checkbox" id='chkbox{{i}}' name='selectAccount{{i}}'
                                    (change)="addRemovePayor($event, i)" [checked]=payor.isSelected>
                                <span class="checkmark"></span>
                            </label>
                        </td>
                        <td>{{payor.lastName | uppercase}}</td>
                        <td>{{payor.ssn | maskdata: 4}}</td>
                        <td *ngIf="validateCaseNumber">{{payor.caseNumber}}</td>
                        <td>{{payor.amount | currency:'USD':'symbol':'.2-5'}}</td>
                        <td>
                            <span matTooltip="EDIT PAYOR" matTooltipClass="tooltip-md" (click)="editPayor(payor, i)"
                                class="fa fa-pencil-square-o fa-md-blue">
                            </span>
                            <span matTooltip="DELETE PAYOR" matTooltipClass="tooltip-md" (click)="deletePayor(i)"
                                class="fa fa-trash-o fa-md-blue ml-2">
                            </span>
                        </td>
                        <td>
                            <span *ngIf="payor.isSelected && payor.isValidated && !payor.hasError && !payor.hasWarning"
                                class="c-green0">
                                <i class="fa fa-check fa-md-green" matTooltip="VALID PAYOR"
                                    matTooltipClass="tooltip-md"></i>
                                Valid Payor
                            </span>
                            <span *ngIf="payor.isSelected && payor.hasError" class="c-red1">
                                <i matPrefix class="fa fa-times-circle fa-md-red" matTooltip="INVALID PAYOR"
                                    matTooltipClass="tooltip-md"></i>
                                {{payor.errorMessage}}
                            </span>
                            <span *ngIf="payor.isSelected && payor.hasWarning && !payor.hasError" class="c-gold0">
                                <i matPrefix class="fa fa-exclamation-triangle fa-md-yellow" matTooltip="WARNING"
                                    matTooltipClass="tooltip-md"></i>
                                {{payor.errorMessage}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p *ngIf="!atLeastOnePayorSelected && validateAttemptMade" class="c-red1 mt-1">
            <i matPrefix class="fa fa-exclamation-triangle fa-md-red"></i>
            Please select at least one Payor to Validate.
        </p>
        <p *ngIf="(totalAmtOfPayments > 9999.99) && validateAttemptMade" class="c-red1 mt-1">
            <i matPrefix class="fa fa-exclamation-triangle fa-md-red"></i>
            Payment amount cannot exceed $9999.99.
        </p>
        <p *ngIf="(totalAmtOfPayments < 1.00) && validateAttemptMade" class="c-red1 mt-1">
            <i matPrefix class="fa fa-exclamation-triangle fa-md-red"></i>
            Payment amount must exceed $0.99.
        </p>
        <p *ngIf="nameChangeOccured && validateAttemptMade" class="c-gold0 mt-1">
            <i matPrefix class="fa fa-exclamation-triangle fa-md-yellow"></i>
            Please Validate again to confirm name change.
        </p>
    </div>
</form>
<div class="flex-btn-row pt-2 pb-2">
    <button class="btn btn-secondary" mat-button matStepperPrevious>Back</button>

    <button *ngIf="!payorsValid" type="button" [disabled]="payorCollection.length === 0" class="btn btn-submit"
        mat-button (click)="validatePayors()">
        Validate Payors
    </button>
    <button *ngIf="payorsValid" [disabled]="totalAmtOfPayments >= 9999/.99" class="btn btn-primary-short" mat-button
        (click)="emitValidPayorPerValidation()" matStepperNext>Next</button>
</div>